import Vue from 'vue';
import VueRouter from 'vue-router';

import Login from '@/views/login.vue';
import Main from '@/views/Main.vue';
import RecyclingData from '@/views/recyclingData.vue';
import DeviceInfo from '@/views/deviceInfo.vue';
import MonitoringInspection from '@/views/monitoringInspection.vue';
import OrderSystem from '@/views/orderSystem.vue';
import Outside from '@/views/outside.vue';
import DeviceMonitor from '@/views/deviceMonitor.vue';
import Partners from '@/views/partners.vue';



Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/main',
    name: 'MainPage',
    component: Main
  },
  {
    path: '/recycling-data',
    name: 'RecyclingData',
    component: RecyclingData
  },
  {
    path: '/deviceInfo',
    name: 'DeviceInfo',
    component: DeviceInfo
  },
  {
    path: '/monitoringInspection',
    name: 'MonitoringInspection',
    component: MonitoringInspection
  },
  {
    path: '/orderSystem',
    name: 'orderSystem',
    component: OrderSystem
  },
  {
    path: '/outside',
    name: 'outside',
    component: Outside
  },
  {
    path: '/deviceMonitor',
    name: 'deviceMonitor',
    component: DeviceMonitor
  },
  {
    path: '/partners',
    name: 'partners',
    component: Partners
  },
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;
